module.exports = __webpack_public_path__ + "img/mug-hot-regular.39c02d73.svg";